const doc = [({"en":({"js":({"users":({"edit":({"school":({"school":"School", "choose_school":"Choose school"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;